var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.item.path},on:{"click":_vm.onClick}},[(_vm.item.icon)?_c('i',{class:_vm.item.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }